import { CartItems } from './cart-items.model';

export class CartItemList {
  public id: Number;
  public cartItems: CartItems[] = [];
}
